import React, { Component } from 'react';
import i from '../imports';

const itemStyle = {
    marginTop: 10,
    marginBottom: 20,
    // width: 200,
    textAlign: "center",
    marginLeft: "auto",
    marginRight: "auto",
    display: "inline-block"
}

const photoStyle = {
    // margin: 0,
    borderRadius: '50% 50%',
    width: 150,
    height: 150,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    textAlign: "center",
    display: "inline-block"
}

const nameStyle = {
    fontSize: 16,
    color: "gray",
    fontWeight: "bold"
}

const contactStyle = {
    fontSize: 16,
    color: "gray"
}

class OurTeamItem extends Component {
    render() {
        let item = this.props.item;
        return (
            <div style={itemStyle}>
                <div className="our-team-photo" 
                    style={Object.assign({
                        backgroundImage: `url('${item.photo}')`
                    }, photoStyle)}>
                </div>
                <div style={{paddingTop: 10, paddingBottom: 10}}>
                    <div style={nameStyle}>{item.translations[0].name}</div>
                    <div style={nameStyle}>{item.translations[0].position}</div>
                </div>
                <div style={contactStyle}><i.Icon icon={i.faIcons.envelopeO} />&nbsp;&nbsp;{item.email}</div>
                <div style={contactStyle}><i.Icon icon={i.faIcons.phone} />&nbsp;&nbsp;{item.phone}</div>
            </div>
        );
    }
}

export default OurTeamItem;